export const formatDate = (dateString: string | null | undefined, locale: string = 'tr'): string => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';

  const localeMap: { [key: string]: string } = {
    'tr': 'tr-TR',
    'en': 'en-US',
    'ar': 'ar-SA',
    'krm': 'ku-TR',
    'kmr': 'ku-TR' // Fallback for Kurmanji
  };

  const targetLocale = localeMap[locale] || 'tr-TR';
  
  return date.toLocaleDateString(targetLocale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
};

export const formatTime = (dateString: string | null | undefined, locale: string = 'tr'): string => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';

  const localeMap: { [key: string]: string } = {
    'tr': 'tr-TR',
    'en': 'en-US',
    'ar': 'ar-SA',
    'krm': 'ku-TR',
    'kmr': 'ku-TR'
  };

  const targetLocale = localeMap[locale] || 'tr-TR';

  return date.toLocaleTimeString(targetLocale, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
};

export const formatDateTime = (dateString: string | null | undefined, locale: string = 'tr'): string => {
  if (!dateString) return '';
  const dateStr = formatDate(dateString, locale);
  const timeStr = formatTime(dateString, locale);

  if (!dateStr) return '';
  if (!timeStr) return dateStr;

  return `${dateStr} • ${timeStr}`;
};
